<template>
  <div class="page-content-wrapper">
    <div class="page-content lift">
      <!-- BEGIN PAGE HEADER-->
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <i class="fa fa-home"></i>
            <a href="index.html">首页</a>
            <i class="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">梯控设备</a>
          </li>
        </ul>
      </div>
      <!-- END PAGE HEADER-->
      <div>
        <div id="search-bar">
          <select id="community_select2" class="form-control select2 select2-allowclear">
            <option v-for="item in communities" :value="item.id">{{item.description}}</option>
          </select>
          <input style="margin-left: 3px;" type="text" placeholder="输入设备描述" class="form-control search-bar-item" name="desc" v-model="biz.desc" id="desc" />
          <input type="text" placeholder="输入设备MAC" class="form-control search-bar-item" name="mac" v-model="biz.mac" id="mac" />
          <button type="button" class="btn green" @click="search">
            查询
            <i class="fa fa-search"></i>
          </button>
          <button v-if="auth('biz_lift_file')" type="button" class="btn green" @click="imp">
            导入设备
            <i class="fa fa-upload"></i>
          </button>
          <button v-if="auth('biz_lift_del')" type="button" class="btn red" @click="remove">
            删除
            <i class="fa fa-remove"></i>
          </button>
        </div>
        <select v-if="false" @change="test($event)" class="my-selector form-control">
          <option value>-</option>
          <option v-for="addr in level1Addrs" :value="addr.addr_id" v-bind:key="addr.id">{{addr.description}}</option>
        </select>
      </div>
      <table class="table table-striped table-hover table-bordered table-condensed">
        <thead>
          <tr>
            <th width="7%">
            <input type="checkbox" name="check-title" @change="changeCheckbox($event,0,0)" id="check-all"> 全选
            </th>
            <th width="13%">MAC</th>
            <th width="20%">描述</th>
            <!-- <th width="13%">主控板MAC</th> -->
            <!-- <th width="8%">物理ID</th> -->
            <th width="25%">安装位置</th>
            <th width="6%">控制口</th>
            <!-- <th width="6%">权限组</th> -->
            <th width="11%">创建时间</th>
            <th width="11%">修改时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in lift_list">
            <td style="text-align:center">
            <input type="checkbox" name="check-item" @change="changeCheckbox($event,1,item.id)" :id="item.id">
            </td>
            <td class="text-center">{{ item.main_mac}}</td>
            <td>{{ item.description }}</td>
            <!-- <td>{{ item.main_mac}}</td> -->
            <td>{{ addrLabel(item.addrs)}}</td>
            <!-- <td>{{ item.community.community }}</td> -->
            <td>{{ item.io_count }}</td>
            <!-- <td>{{ item.right_group }}</td> -->
            <td class="time">{{ dtFormat(item.create_time, 'yyyy-MM-DD HH:mm') }}</td>
            <td class="time">{{ dtFormat(item.update_time, 'yyyy-MM-DD HH:mm') }}</td>
            <td style="text-align:center">
              <a v-if="auth('biz_lift_detail')" href="javascript:;" @click="detail(item.id)">详情</a>
              <a v-if="auth('biz_lift_del')" href="javascript:;" @click="remove(item.id, $event)">删除</a>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="pager-bar">
        <pager :page-index="pageIndex" :page-size="pageSize" :total-count="totalCount" :action="query" @page-change="onPageChange"></pager>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../lib/utils/request.js'
// import fileutil from '../lib/utils/fileutil.js'
import commonMethods from '../lib/methods/common.js'
import Pager from './fragment/Pager.vue'
import LiftDetail from './LiftDetail.vue'
import UploadPannel from './UploadPannel.vue'
import BootstrapModal from './fragment/BootstrapModal.vue'
import { MSG_ID, K_LOGINED_USER } from '../lib/constant'
import { mapState } from 'vuex'
import mixins from '../mixins'
import mixinTableCheckbox from '../mixins/table-checkbox.js'
import db from '../store/local'

export default {
  mixins: [...mixins, mixinTableCheckbox],
  name: 'lock',
  data () {
    return {
      lift_list: [],
      // 列表分页用数据
      pageIndex: 1,
      pageSize: 15,
      totalCount: 0,
      biz: {
        mac: '',
        desc: ''
      },
      communities: []
    }
  },
  components: {
    LiftDetail,
    UploadPannel,
    BootstrapModal,
    Pager
  },
  created () {
  },
  mounted () {
    window.emitter.on(MSG_ID.MSG_LOCK_REFRESH, (...args) => {
      this.query()
    })
    this.communities = db.get(K_LOGINED_USER).account.communities
    // window.emitter.emit(MSG_ID.MSG_UI_INFLATE_SELECT2, '#test-id')
    window.$('#community_select2').select2({
      allowClear: false
    })
    this.fill()
    this.query()
  },
  methods: {
    onPageChange (pageIndex) {
      this.query()
    },
    search () {
      // uncheck all
      this.uncheckAll()
      this.resetPager()
      this.query()
    },
    fill () {
      let reqdata = { parent_addr_id: '0', page_index: 1, page_size: 500 }
      http.invoke('addr.pageAddr', reqdata, (data0) => {
        this.level1Addrs = data0.content
        setTimeout(() => {
          window.$('#community_select2').select2('val', this.communities[0].id)
        }, 300)
      })
    },
    query () {
      this.uncheckAll()
      let cid = window.$('#community_select2').select2('val')
      let reqdata = {
        main_mac: this.biz.mac,
        desc: this.biz.desc,
        uid: db.get(K_LOGINED_USER).account.id,
        community_id: cid,
        page_index: this.pager.pageIndex,
        page_size: this.pageSize
      }
      console.log(reqdata)
      http.post('lift.pageLift', reqdata, { session: this.session() }, (data) => {
        this.lift_list = data.content
        this.totalCount = data.total_count
      }, (res) => {
        console.log(res)
      })
    },
    detail (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, LiftDetail, { title: '设备详情页', id: id })
    },
    imp (id) {
      window.emitter.emit(MSG_ID.MSG_UI_SHOW_MODAL, UploadPannel, { title: '设备数据导入', url: '/lift/upload' })
    },
    remove (id, el) {
      if (+id > 0 || this.willRemoved.size > 0) {
        window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '确认删除梯控信息', () => {
          let reqdata = { ids: (+id > 0 ? [id] : [...this.willRemoved]) }
          http.post('lift.remove', reqdata, {}, this.query, () => { })
        })
      } else {
        window.emitter.emit(MSG_ID.MSG_UI_TIP_WARN, '请选中需要删除的数据')
      }
    },
    addrLabel (addrs) {
      console.log(addrs)
      if (!addrs) {
        return ''
      }
      let lables = []
      for (let addr of addrs) {
        lables.push(addr.description)
      }
      return lables.join('-')
    },
    ...commonMethods
  },
  computed: {
    ...mapState({
      pager: state => state.pager
    })
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-selector {
  display: inline;
  max-width: 150px;
}

.lift {
  background-color: #fff;
}

#search-bar {
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#pager-bar {
  text-align: center;
}

.search-bar-item {
  flex-grow: 1;
  margin-right: 3px;
}

.table th {
  text-align: center;
}

@media screen and (max-width: 767px) {
  .mh {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// Lift.vue?cf16da40